import { useEffect, useState } from 'react';

import {
  TEMApplication,
  TEmbeddedModeState,
  TEMChangeApplicationOptions,
  TEMStateManager,
} from './embed-mode.types';
import { transformAPIToEMData } from './embed-mode-transformers.helper';

export const useEMStateManager = (): TEMStateManager => {
  const [EMState, setEMState] = useState<TEmbeddedModeState>({
    state: null,
    changeApplication: null,
    getApplicationById: null,
  });

  const changeApplication = (
    application: TEMApplication,
    options?: TEMChangeApplicationOptions
  ): void => {
    setEMState((prevState: TEmbeddedModeState): TEmbeddedModeState => {
      const foundApplicationIndex = prevState?.state?.apps.findIndex(
        (app: TEMApplication) => app.appId === application.appId
      );
      const apps: TEMApplication[] =
        (foundApplicationIndex !== -1
          ? prevState?.state?.apps.map((app: TEMApplication, idx: number) =>
              idx === foundApplicationIndex ? application : app
            )
          : prevState?.state?.apps.concat(application)) || [];

      if (!options?.silence) {
        const updatedApplication =
          foundApplicationIndex && foundApplicationIndex !== -1
            ? apps[foundApplicationIndex]
            : application;

        const message = {
          method: 'changeAppStatus',
          payload: updatedApplication,
        };

        window.parent.postMessage(message, '*');
      }

      return {
        ...prevState,
        state: !prevState.state
          ? prevState.state
          : { ...prevState.state, apps },
      };
    });
  };

  changeApplication.transformAPIToEMData = transformAPIToEMData;

  const getApplicationById = (id: string): TEMApplication | null => {
    return (
      EMState.state?.apps.find((app: TEMApplication) => app.appId === id) ||
      null
    );
  };

  useEffect(() => {
    setEMState((prevState: TEmbeddedModeState) => ({
      ...prevState,
      changeApplication,
      getApplicationById,
    }));
  }, []);

  return {
    state: EMState.state,
    setState: setEMState,
    changeApplication,
    getApplicationById,
  };
};
